import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVirtualTrip } from "../../common/plannerTypes";

export interface IPlannerModalState {
  showTripDetails: boolean;
  tripDetails: IVirtualTrip | null;
  tripDetailsModalType: string | null;
  blockLabel: string | null;
  noOfPatientSeats: number;
  noOfStretchers: number;
  showLayerUnder: boolean;
}

export interface IPlannerModalStatePayload {
  showTripDetails: boolean;
  tripDetails: IVirtualTrip | null;
  tripDetailsModalType: string | null;
  blockLabel: string | null;
  noOfPatientSeats?: number | null;
  noOfStretchers?: number | null;
  showLayerUnder?: boolean | null;
}

const initialState: IPlannerModalState = {
  showTripDetails: false,
  tripDetails: null,
  tripDetailsModalType: null,
  blockLabel: null,
  noOfPatientSeats: 0,
  noOfStretchers: 0,
  showLayerUnder: false,
};

const plannerSliceModal = createSlice({
  name: "plannerModalStore",
  initialState,
  reducers: {
    showTripDetailsModal(state: IPlannerModalState, action: PayloadAction<IPlannerModalStatePayload>) {
      state.showTripDetails = action.payload.showTripDetails;
      state.tripDetails = action.payload.tripDetails;
      state.tripDetailsModalType = action.payload.tripDetailsModalType;
      state.blockLabel = action.payload.blockLabel;
      state.noOfPatientSeats = action.payload?.noOfPatientSeats ?? 0;
      state.noOfStretchers = action.payload?.noOfStretchers ?? 0;
      state.showLayerUnder = action.payload?.showLayerUnder ?? false;
    },
  },
});

export const { showTripDetailsModal } = plannerSliceModal.actions;

export default plannerSliceModal.reducer;
